import { IsBoolean, IsOptional } from 'class-validator';

/**
 * @see backend-php/modules/rest_common/models/taxonomy/FieldProfile.php
 */
export class FieldProfileOptions {
    @IsOptional()
    @IsBoolean({ message: 'Должно быть boolean' })
    public printUnwrapProfileSticker: boolean;

    constructor(data?: Partial<FieldProfileOptions>) {
        this.printUnwrapProfileSticker = data?.printUnwrapProfileSticker;
    }
}
